# GraphQL fragment to get basic info about an activity

fragment FullActivity on Activity {
    id
    type
    name
    htmlUrl
    startTime
    endTime
    isLogged
    isAllDay
    isOverdue
    agenda
    showTranscribeLoggingFlow
    externalMeetingServiceType
    participants {
        id
        name
        ... on Contact {
            type
        }
        ... on User {
            type
        }
        ... on Account {
            type
        }
        ... on Lead {
            type
        }
    }
}
